// Import the Axios library to make HTTP requests. Axios is a popular JavaScript library for this purpose.
import axios from 'axios';
import { API_BASE_URL } from './constants';
import Cookies from 'js-cookie';
// Pull saved language for Accept-Language header
const savedLang = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
const savedCountry = typeof window !== 'undefined' ? localStorage.getItem('country') : null;
const acceptLanguage = savedLang ? (savedCountry ? `${savedLang}-${savedCountry}` : savedLang) : undefined;

const apiInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(acceptLanguage && { 'Accept-Language': acceptLanguage })
    }
})

// Apply rewrites only in local dev to avoid 404s on production (Railway)
apiInstance.interceptors.request.use((config) => {
    if (!config || !config.url) return config;

    const isLocal = API_BASE_URL.includes('127.0.0.1') || API_BASE_URL.includes('localhost');
    if (!isLocal) {
        // Don't apply rewrites for production (Railway) - return config as-is
        return config;
    }

    const originalUrl = config.url;
    const hasLeadingSlash = originalUrl.startsWith('/');
    const normalized = hasLeadingSlash ? originalUrl.slice(1) : originalUrl;

    const mappings = [
        ['offers-carousel/', 'r7/'],
        ['most-viewed-products/', 'r6/'],
        ['carousel-config/', 'r3/'],
        ['carousel/', 'r4/'],
        ['banners/', 'r5/'],
        ['categories/', 'r1/'],
        ['products/', 'r2/'],
        ['cart-list/', 'bk/items/'],
        ['cart-detail/', 'bk/detail/'],
        ['cart-view/', 'bk/'],
        ['cart-update/', 'bk/update/'],
        ['cart-delete/', 'bk/remove/'],
    ];

    for (const [from, to] of mappings) {
        if (normalized.startsWith(from)) {
            const remainder = normalized.slice(from.length);
            config.url = `${to}${remainder}`;
            break;
        }
    }

    return config;
});

// Base URL points to Railway in prod via constants; interceptor keeps path neutral.

// Production-ready function to create authenticated axios instance
export const createAuthenticatedAxios = () => {
    const access_token = Cookies.get("access_token");
    
    const instance = axios.create({
        baseURL: API_BASE_URL,
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...(access_token && { Authorization: `Bearer ${access_token}` })
        }
    });
    
    console.log('createAuthenticatedAxios: Created instance:', instance);
    console.log('createAuthenticatedAxios: Instance type:', typeof instance);
    console.log('createAuthenticatedAxios: Available methods:', Object.getOwnPropertyNames(instance));
    
    return instance;
};

export default apiInstance